import React from 'react';
import ApiConfigForm from '../components/ApiConfigForm';

export default function AdminSettingsPage() {
	return (
		<div className="admin-settings-page">
			<h2>Settings</h2>
			<p className="page-subtitle">Configure API keys, environment, and application preferences.</p>
			<ApiConfigForm />
		</div>
	);
}
